
<template>
    <div class="reveal-overlay photo-overlay">
        <div class="reveal-photo">
            <div class="pane">
                <div class="preview" ref="container">
                    <template v-if="measured && photo">
                        <img :src="`${ photo.url }.large.jpg`" :width="photo.width" :height="photo.height" :style="style"/>
                    </template>
                </div>

                <div class="details">
                    <template v-if="photo">
                        <header>
                            <h2>{{ shoot.title }}</h2>
                            <router-link :to="{ name: 'shoot', params: { id: shoot.shoot_id } }" class="del close">back to gallery <span class="icon-right"></span></router-link>
                        </header>

                        <div class="photo-pagination">
                            <router-link v-if="index !== 0" :to="{ name: 'photo', params: { photo_id: this.previous } }" class="prev-img icon-left del">back</router-link>
                            <span v-else class="prev-img icon-left del">back</span>

                            <p>{{ index + 1 }}/{{ photos.length }}</p>

                            <router-link v-if="index < photos.length -1" :to="{ name: 'photo', params: { photo_id: this.next } }" class="next-img del">next <span class=" icon-right"></span></router-link>
                            <span v-else class="next-img del">next <span class=" icon-right"></span></span>
                        </div>

                        <div class="content">
                            <dl class="metadata" v-if="auth.user && auth.user.superuser">
                                <dt>File name:</dt>
                                <dd>{{ photo.filename }}</dd>

                                <dt>Actions:</dt>
                                <dd><span v-on:click="photo.destroy()" style="text-decoration:underline;cursor:pointer">delete</span></dd>
                            </dl>


                            <h2 class="production">Add to basket</h2>
                            <p>Delivery charges may apply</p>

                            <a v-for="productType in types" v-on:click="showType( productType )" class="product-toggle" :class="{ selected: type === productType }">{{ productType }}</a>

                            <ul class="products" v-if="type && products[type].length">
                                <li v-for="( product, index ) in products[type]">
                                    <input type="radio" :value="product.product_version_id" v-model.number="selected[type]" :id="`product${ index }`"/>

                                    <label :for="`product${ index }`">
                                        <h2>{{ product.title }}</h2>
                                        <p v-if="product.description">{{ product.description }}}</p>

                                        <dl class="metadata" v-if="product.dimensions && selected[type] === product.product_version_id">
                                            <dt>Dimensions:</dt>
                                            <dd>{{ product.dimensions }}</dd>
                                        </dl>
                                    </label>

                                    <span><span class="in-basket" v-if="quantity[product.product_version_id]">{{ quantity[product.product_version_id] }}x</span> {{ $root.currency( product.price ) }} </span>
                                </li>
                            </ul>

                            <footer>
                                <button class="button is-primary" style="width:100%" :class="{ disabled: selected[type] === null, 'is-loading': basket && basket.saving }" :disabled="selected[type] === null || ( basket && basket.saving )" v-on:click="add">Add to basket</button>
                            </footer>
                        </div>
                    </template>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
	import Item from '../models/Item';
	import moment from 'moment';
	import Product from '../models/Product';
    import session from '../support/Session';
    import auth from '../support/Auth';

	export default
    {
    	computed:
        {
	        quantity()
            {
            	const quantity = {};
            	for( const type in this.products ) {
		            for( const product of this.products[type] ) {
			            const item = this.basket.items.find( item => item.product_version_id === product.product_version_id && item.photo_id === this.photo.photo_id );
			            quantity[product.product_version_id] = item instanceof Item ? item.quantity : 0;
		            }
                }

            	return quantity;
            },
        	shoot()
            {
                return this.$parent.shoot;
            },
        	index()
            {
	            return this.photos.indexOf( this.photo );
            },
        	next()
            {
                const index = this.photos.indexOf( this.photo ),
	                next = index >= this.photos.length ? index : index +1;

                return this.photos[next] ? this.photos[next].photo_id : this.photos.length -1;
            },
            previous()
            {
	            const index = this.photos.indexOf( this.photo ),
                    previous = index <= 0 ? index : index -1;

	            return this.photos[previous] ? this.photos[previous].photo_id : 0;
            },
            photo()
            {
                return this.photos.find( photo => photo.photo_id === + this.photo_id );
            },
            style()
            {
                const photo = this.photo;
                if( photo === null )
                	return {};

                const containerRatio = this.$refs.container.clientWidth / this.$refs.container.clientHeight,
                    photoRatio = photo.width / photo.height;


                let height = this.$refs.container.clientWidth / photoRatio;
                if( height < this.$refs.container.clientHeight ) {
                	return {'margin-top': ((this.$refs.container.clientHeight - height )/ 2) + 'px'};
                }
                return {};
            },
            basket()
            {
            	return this.session.basket;
            },
        },
	    data()
        {
            return {
            	auth,
	            session,
            	photos: [],
	            products: null,
	            selected: {
            		canvas: null,
                    print: null,
                },
	            measured: false,
                type: null,
                types: [],
            };
        },
        methods:
        {
	        showType( type )
            {
            	this.type = type;
            },
	        add()
            {
            	const item = new Item;
            	item.product_version_id = this.selected[this.type];
            	item.photo_id = this.photo.photo_id;

            	this.basket.add( item );
            },
            date( date )
            {
            	date = new Date( date ).getTime();
            	return moment( date ).format( 'h:mm A, Do MMMM YYYY' );
            },
	        inBasket( product, photo )
	        {
		        const item = this.basket.items
		        .find( item => item.product_version_id === product && item.photo_id === photo );

		        return item instanceof Item ?
			        item.quantity : 0;
	        }
        },
        mounted()
        {
            this.photos = this.$parent.shoot.photos;

            Product.all().then( products => {
            	products = products.reduce(function( r, a ){
		            r[a.type] = r[a.type] || [];
		            r[a.type].push(a);
		            return r;
	            }, {} );

            	this.types = Object.keys(products);
            	this.type = this.types[0];

            	for( const type of this.types )
            		this.selected[type] = products[type][0].product_version_id;

            	this.products = products;
            });

            this.$nextTick( () => {
                this.measured = true;
            });
        },
        props:
        {
            photo_id: {
            	required: true,
            	//type: Number,
            }
        },
	};
</script>
